import React from 'react';
import { createRoot } from 'react-dom/client';
import FlashMessages from './FlashMessages';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('flash-messages-container');
  if (container) {
    const messages = JSON.parse(container.dataset.flash);
    const root = createRoot(container);
    root.render(<FlashMessages messages={messages} />);
  }
});
